

























































import Vue from 'vue';
import _ from 'lodash';

import { Historico } from '../../../../back/src/entity/Historico';
import { HistoricoPergunta } from '../../../../back/src/entity/HistoricoPergunta';
import { TipoHistorico, HistoricoHelper, PacientePutFormData } from '../../../../back/src/types';

import { tipoHistoricoStrings } from '../../utils/constants';

import TheHistoricoTab from '../historicos/TheHistoricoTab.vue';
import ThePacientesCondicoesEspeciaisAlert from './ThePacientesCondicoesEspeciaisAlert.vue';

export default Vue.extend({
  name: 'ThePacientesDadosHistoricos',
  components: {
    TheHistoricoTab,
    ThePacientesCondicoesEspeciaisAlert,
  },
  props: {
    pacienteId: {
      type: Number,
    },
    condicoesEspeciais: {
      type: String,
    },
    historicos: {
      type: Array as () => Historico[],
    },
    historicoPerguntas: {
      type: Array as () => HistoricoPergunta[],
    },
  },
  data() {
    return {
      tab: 0,
      historicosHelper: [] as HistoricoHelper[],
    };
  },
  computed: {
    historicosSorted(): Historico[] {
      return _.sortBy(this.historicos, el => el.id);
    },
    historicosPreenchidos(): boolean {
      return _.every(this.historicos, el => el.finalizado);
    },
  },
  mounted() {
    this.montaHelper();
  },
  methods: {
    tipoHistorico(tipoHistorico: TipoHistorico): string {
      if (_.has(tipoHistoricoStrings, tipoHistorico)) {
        return tipoHistoricoStrings[tipoHistorico];
      }
      return '';
    },
    montaHelper() {
      this.historicosHelper = _.map(
        this.historicos as Historico[],
        historico => ({ historicoId: historico.id, show: true, verTodas: false }),
      ) as HistoricoHelper[];
    },
    showHistorico(historicoId: number): boolean {
      const historicoHelper = _.find(
        this.historicosHelper as HistoricoHelper[],
        el => el.historicoId === historicoId,
      );
      return historicoHelper ? historicoHelper.show : false;
    },
    verTodasHistorico(historicoId: number): boolean {
      const historicoHelper = _.find(
        this.historicosHelper as HistoricoHelper[],
        el => el.historicoId === historicoId,
      );
      return historicoHelper ? historicoHelper.verTodas : false;
    },
    toggleShowHistorico(historicoId: number) {
      const index = _.findIndex(
        this.historicosHelper as HistoricoHelper[],
        el => el.historicoId === historicoId,
      );
      if (index >= 0) {
        this.$set(this.historicosHelper[index], 'show', !this.historicosHelper[index].show);
      }
    },
    toggleVerTodasHistorico(historicoId: number) {
      const index = _.findIndex(
        this.historicosHelper as HistoricoHelper[],
        el => el.historicoId === historicoId,
      );
      if (index >= 0) {
        this.$set(this.historicosHelper[index], 'verTodas', !this.historicosHelper[index].verTodas);
      }
    },
  },
});
